import {
	Component,
	OnInit,
	CUSTOM_ELEMENTS_SCHEMA,
	NO_ERRORS_SCHEMA,
	inject,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

import { ContentService } from '../../services/content.service';
import { SHARED_IMPORTS } from '../shared/shared-imports';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'user-activity-log-component',
	standalone: true,
	templateUrl: 'components/user-activity-log/user-activity-log.component.html',
	imports: [...SHARED_IMPORTS, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatNativeDateModule, MatIconModule],
	providers: [DatePipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UserActivityLogComponent implements OnInit {
	public orderByField = '';
	public reverseSort = false;

	public startDate: Date = new Date();
	public endDate: Date = new Date();
	public endDateMax: Date;
	public myDate: Date = new Date();

	public logs: any[] = [];
	public filterText: string = '';
	public startDateFilter: number;
	public endDateFilter: number;
	public endDateMaxTemp: Date;

	public enterStartDate: string;
	public enterEndDate: string;

	private router = inject(Router);
	private content = inject(ContentService);
	private http = inject(HttpClient);
	private datePipe = inject(DatePipe);

	constructor() {
		this.startDate.setDate(this.startDate.getDate() - 7);
		this.startDate.setHours(0, 0, 0);
		this.endDate.setHours(23, 59, 59);
		this.endDateMax = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

		this.filterText = localStorage.getItem('filterText') || '';
	}

	ngOnInit(): void {
		this.enterStartDate = this.content.getContent("UserActivityLog.EnterStartDate");
		this.enterEndDate = this.content.getContent("UserActivityLog.EnterEndDate");
		this.getUserActivityLogs();
	}

	getUserActivityLogs(): void {
		const url = `/api/userActivityLog/Get?startDate=${this.startDate.toISOString()}&endDate=${this.endDate.toISOString()}`;
		this.http.get<any[]>(url).subscribe((data) => {
			this.logs = data;
			this.doFilterStart();
			this.doFilterEnd();

			this.logs.forEach((log: any) => {
				log.TimestampFormat = this.datePipe.transform(log.Timestamp, 'EEEE, MMMM d, y HH:mm:ss');
			});

			const h1 = document.querySelector('.logFirstFix')?.clientHeight || 0;
			const h2 = document.querySelector('.sdm-headerFix')?.clientHeight || 0;
			const h3 = document.querySelector('.navbar-fixed-top')?.clientHeight || 0;
			const totalHeight = window.innerHeight - h1 - h2 - h3;
			const scrollEl = document.getElementById('tableScrollable');
			if (scrollEl) scrollEl.style.maxHeight = `${totalHeight}px`;
		});
	}

	getAutomaticUpdateName(message: string): string {
		return this.content.getContent(message);
	}

	doFilterText(): void {
		this.filterText = this.filterText.toLowerCase();
		localStorage.setItem('filterText', this.filterText);
	}

	updateStartFilter(): void {
		this.getUserActivityLogs();
	}

	updateEndFilter(): void {
		this.getUserActivityLogs();
	}

	doFilterStart(): void {
		this.startDateFilter = this.startDate.getTime();
		localStorage.setItem('startDateFilter', this.startDateFilter.toString());
	}

	doFilterEnd(): void {
		const d = this.endDate ? new Date(this.endDate) : new Date(this.endDateMax);
		d.setHours(23, 59, 59, 59);
		this.endDateFilter = d.getTime();
		localStorage.setItem('endDateFilter', this.endDateFilter.toString());
		this.endDateMaxTemp = new Date(this.endDateFilter);
		this.endDateMax = new Date(this.endDateMaxTemp.getTime());
	}

	private filterMatch(str: string): boolean {
		const current = new Date(str).getTime();
		const start = new Date(this.startDateFilter);
		start.setHours(0, 0, 0, 0);

		if (this.startDate && this.endDate) return start.getTime() <= current && current <= this.endDateFilter;
		if (!this.startDate && this.endDate) return current <= this.endDateFilter;
		if (this.startDate && !this.endDate) return start.getTime() <= current;

		return true;
	}

	private filterMatchText(str: string): boolean {
		return str?.toLowerCase().includes(this.filterText);
	}

	showRecord(record: any): boolean {
		return this.filterMatch(record.Timestamp);
	}

	showRecordText(record: any): boolean {
		return (
			this.filterMatchText(record.LogMessageLocal) ||
			this.filterMatchText(record.AppUserEmail) ||
			this.filterMatchText(record.LocationPath) ||
			this.filterMatchText(record.UnitSerialNumber)
		);
	}

	goBack(): void {
		this.router.navigate(['/Main']);
	}
	get filteredLogs(): any[] {
		return this.logs
			.filter(log => this.showRecord(log) && this.showRecordText(log))
			.sort((a, b) => {
				const field = this.orderByField;
				if (!field) return 0;

				const aVal = a[field];
				const bVal = b[field];
				if (aVal === bVal) return 0;

				const comparison = aVal > bVal ? 1 : -1;
				return this.reverseSort ? -comparison : comparison;
			});
	}

}
